<script setup lang="ts">
import { computed } from 'vue';
import { ALButton } from '@af-lib/vue-ui';

type ButtonType = 'primary' | 'secondary' | 'tertiary';

type Props = {
  /** Shorthand for the discreet secondary action (cancel, back, close) */
  cancel?: boolean;
  type?: ButtonType;
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  to?: string;
};

const props = withDefaults(defineProps<Props>(), {
  cancel: false,
  type: 'primary',
  loading: false,
});

const buttonType = computed<ButtonType>(() => (props.cancel ? 'tertiary' : props.type));
</script>

<template>
  <ALButton
    :type="buttonType"
    :label="props.label"
    :to="props.to"
    :isDisabled="props.disabled"
    :isLoading="props.loading"
  >
    <slot />
  </ALButton>
</template>
